export default __webpack_public_path__ + "static/media/toolbar.149631a3.md";